import { render } from "./GlobalUppyUploader.vue?vue&type=template&id=91b7a160&scoped=true"
import script from "./GlobalUppyUploader.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalUppyUploader.vue?vue&type=script&setup=true&lang=js"

import "./GlobalUppyUploader.vue?vue&type=style&index=0&id=91b7a160&scoped=true&lang=css"
import "./GlobalUppyUploader.vue?vue&type=style&index=1&id=91b7a160&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91b7a160"],['__file',"src/components/ui/GlobalUppyUploader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "91b7a160"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('91b7a160', __exports__)) {
    api.reload('91b7a160', __exports__)
  }
  
  module.hot.accept("./GlobalUppyUploader.vue?vue&type=template&id=91b7a160&scoped=true", () => {
    api.rerender('91b7a160', render)
  })

}


export default __exports__